export default __webpack_public_path__ + "static/media/tracker.e8f4d154.png";